import { ChatActionViewInvoiceColumnKey, ColumnConfig } from '../../model';

export const chatActionViewInvoiceConfig: Record<
  ChatActionViewInvoiceColumnKey,
  ColumnConfig
> = {
  productTitle: {
    name: 'Product Title',
    isComponent: true,
  },
  // batchAndExpiryDate: {
  //   name: 'Batch / Expiry Date',
  //   isComponent: true,
  // },
  // pts: {
  //   name: 'PTS',
  //   alignment: 'flex-end',
  // },
  price: {
    name: 'Price',
    alignment: 'flex-end',
  },
  invoicedQuantity: {
    name: 'Invoiced Qty',
    alignment: 'flex-end',
  },
  totalAmount: {
    name: 'Total Amount',
    alignment: 'flex-end',
  },
  discount: {
    name: 'Discount',
    alignment: 'flex-end',
  },
  taxAmount: {
    name: 'Total Tax',
    alignment: 'flex-end',
  },
  invoicedAmount: {
    name: 'Invoiced Amt.',
    isComponent: true,
    alignment: 'flex-end',
  },
};
